{
  "course_analytics": {
    "title": "Course Analytics",
    "filters": "Filters",
    "course": "Course",
    "select_course": "Select Course",
    "start_date": "From",
    "end_date": "To",
    "min_handicap": "Min HCP",
    "max_handicap": "Max HCP",
    "rounds": "rounds",
    "hole": "Hole",
    "par": "Par",
    "avg_score": "Avg Score",
    "difficulty": "Difficulty",
    "current_hcp": "HCP",
    "calculated_hcp": "Calculated HCP",
    "hcp_diff": "Diff",
    "eagle_or_better": "Eagle or Better",
    "birdies": "Birdie",
    "pars": "Par",
    "bogeys": "Bogey",
    "double_or_worse": "Double Bogey or Worse",
    "no_data": "No data",
    "select_course_prompt": "Select a course to view analytics",
    "round_type": "Round Type",
    "all_rounds": "All Rounds",
    "competition_rounds": "Competition Rounds",
    "practice_rounds": "Practice Rounds",
    "search": "Search",
    "eagle_short": "Eagle-",
    "birdie_short": "Birdie",
    "bogey_short": "Bogey",
    "double_short": "2Bogey+",
    "kicker": "Course Analytics · Results",
    "period": "Period",
    "hcp_range": "Handicap Range",
    "rounds_section": "Rounds",
    "hardest_hole": "Hardest Hole",
    "easiest_hole": "Easiest Hole",
    "quick_nav_meta": "Par {{par}} · avg {{avg}}",
    "table_section": "Table",
    "table_hint": "all {{count}} holes · click a row to view distribution",
    "calculated_hcp_short": "Calc. HCP",
    "holes_section": "Holes",
    "n_count": "n={{count}}",
    "avg_vs_par": "Average vs Par",
    "distribution": "Distribution",
    "difficulty_total": "Difficulty total",
    "export_pdf": "Download PDF",
    "pdf_page": "Page {{page}} / {{pages}}",
    "pdf_table_meta": "all {{count}} holes",
    "pdf_hcp_all": "No filter"
  },
  "admin_dashboard": {
    "title": "Analytics",
    "overview": "Overview",
    "totalUsers": "Total Users",
    "roundsCompleted": "Rounds Completed",
    "competitions": "Competitions",
    "registrations": "Registrations",
    "last30Days": "Last 30 days",
    "trends": "Trends",
    "date": "Date",
    "newUsers": "New Users",
    "rounds": "Rounds",
    "featureUsage": "Feature Usage",
    "ebirdieUsage": "eBirdie Users",
    "socialFeatures": "Social Features Users",
    "paceTracking": "Pace of Play Tracking",
    "weeklyCompetitions": "Weekly Competition Users",
    "payments": "Paying Users",
    "timePeriod": "Time Period",
    "days7": "7 days",
    "days14": "14 days",
    "days30": "30 days",
    "days90": "90 days",
    "noData": "No data available",
    "error_load": "Failed to load data"
  }
}
